// 滾動 acitve 監測
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const entryDiv = document.getElementById(entry.target.id);

          entryDiv.classList.add('active');

          document.querySelectorAll('.c-list-item').forEach((item) => {
            if (item.hash !== '#' + entry.target.id) {
              item.classList.remove('active');
            } else {
              item.classList.add('active');
            }
          })
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -60%',
      threshold: 0
    }
  );
  const elements = document.querySelectorAll('.c-service-item');
  for (const element of elements) {
    observer.observe(element);
  }
})
